
export function getEditorHTMLContent() {
  
  return (window as any).__EDITOR.getHTML();
}